import React, { useEffect, useState } from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { getStaticUrl } from "../../../../utils/getStaticUrl";
import { getJsonFromStorage } from "../../../../utils/getJsonFromStorage";
import { Spinner } from "react-bootstrap";
import "./programas.css";

const interYearEvents = [
  {
    id: "e1",
    position: "2023.5",
    title: "Creación de un Directorio",
    subtitle:
      "Un directorio es un grupo de personas expertas que cuidan que RedMaestra funcione adecuadamente. Nos orientan con su experiencia, revisan que todo se haga de forma responsable y nos ayudan a crecer para que más mujeres puedan aprender y trabajar.",
    iconColor: "#F6B911",
    backgroundColor: "#fffbe6",
    images: ["directorio/10.png", "directorio/11.png", "directorio/12.png"],
  },
  {
    id: "e2",
    position: "2023.5",
    title: "Integración a Women Can Build Latam",
    subtitle:
      "Proyecto internacional que levantará información sobre buenas prácticas y desafíos para la incorporación de más mujeres en la industria de la construcción en países como España, Italia, Argentina y Chile disponiendo de cerca de 400.000 euros para la realización de este proyecto que integra a diferentes organizaciones internacionales.",
    iconColor: "#49448B",
    backgroundColor: "#f3f3fc",
    images: ["programas/3.png"],
  },
];

const staticYearContent = {
  2025: {
    subtitle: "¡Esta historia está por escribirse! ✍️",
    images: [
      "programas/9.png",
      "programas/1.png",
      "programas/2.png",
      "programas/10.png",
      "programas/4.png",

      "programas/6.png",
      "programas/7.png",
      "programas/8.png",

      "programas/5.png",
    ],
  },
  2024: {
    subtitle:
      "La comunidades se consolidan, enfocándonos en su mantención y progreso. Esto nos permitió llegar a las 400 mujeres dentro de la comunidad. 🫂",
    images: ["c_logos/logo-sodimac.png", "c_logos/logo-santotomas.png"],
  },
  2023: {
    subtitle:
      "Se forman múltiples comunidades en cada uno de los oficios llegando a las 300 maestras y nos expandimos a 5 regiones del país. 👷🏻‍♀️🧰🙌",
    images: [
      "c_logos/logo-lipigas.png",
      "c_logos/logo-wcb.png",
      "c_logos/logo-uct.png",
    ],
  },
  2022: {
    subtitle:
      "Creamos una comunidad con más de 200 maestras y agregamos dos nuevos oficio: electricidad⚡ y climatización.⛅",
    images: [
      "c_logos/logo-eurofred.png",
      "c_logos/logo-socovesa.png",
      "c_logos/logo-cecra.png",

      "c_logos/logo-esser.png",
      "c_logos/logo-h2o.png",
      "c_logos/logo-procap.png",
      "c_logos/logo-ld.png",
      "c_logos/logo-sonepar.png",

      "c_logos/logo-madeco.png",
      "c_logos/logo-polpaico.png",
      "c_logos/logo-schneider.png",
    ],
  },
  2021: {
    subtitle:
      "Formamos a más de 100 mujeres y agregamos el oficio de terminaciones. 💪👷🏻‍♀️",
    images: [
      "c_logos/logo-maestra.png",
      "c_logos/logo-aconcap.png",
      "c_logos/logo-fmc.png",
      "c_logos/logo-construmart.png",

      "c_logos/logo-tarragona.png",
      "c_logos/logo-us+.png",
      "c_logos/logo-guzman.png",
      "c_logos/logo-antofa.png",
      "c_logos/logo-inacap.png",
      "c_logos/logo-vinilit.png",
    ],
  },
  2019: {
    subtitle: "¡Primeras 20 mujeres capacitadas en gasfitería! 👏",
    images: [
      "c_logos/logo-sura.png",
      "c_logos/logo-gili.png",
      "c_logos/logo-infocap.png",
    ],
  },
};

function Programa() {
  const [timelineData, setTimelineData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openBoxIndex, setOpenBoxIndex] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getJsonFromStorage("convocatorias.json");
      if (Array.isArray(data)) {
        setTimelineData(data);
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="banner-loading">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  // Group data by year
  const groupedByYear = timelineData.reduce((acc, item) => {
    const year = item.inicio.split("-")[2];
    if (!acc[year]) acc[year] = [];
    acc[year].push(item);
    return acc;
  }, {});

  return (
    <div className="programas-timeline">
      <h2 className="timeline-title">
        Línea de Tiempo: <br />
        <span style={{ fontSize: "12px" }}>
          De 20 a 400 maestras en menos de 5 años
        </span>
      </h2>
      <VerticalTimeline>
        {Object.entries(groupedByYear).flatMap(([year, items]) => {
          const yearElement = (
            <VerticalTimelineElement
              key={`year-${year}`}
              date={year}
              iconStyle={{
                background: "#49448B",
                color: "#fff",
                boxShadow: "0 0 0 4px #F6B911",
              }}
              contentStyle={{
                background: "#fff",
                borderLeft: "6px solid #F6B911",
                boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
              }}
              contentArrowStyle={{ borderRight: "7px solid #F6B911" }}
            >
              <h3 className="vertical-timeline-element-title">
                Programas {year}
              </h3>

              {staticYearContent[year] && (
                <>
                  <h6 className="timeline-subtitle">
                    {staticYearContent[year].subtitle}
                  </h6>
                  <div className="timeline-image-grid">
                    {staticYearContent[year].images.map((img, i) => (
                      <img
                        key={i}
                        src={getStaticUrl(img)}
                        alt={`programa-${i}`}
                        className="timeline-image"
                      />
                    ))}
                  </div>
                </>
              )}

              {items.map((item, index) => {
                const bgColors = [
                  "#f9f9f9",
                  "#fdf5e6",
                  "#eef6ff",
                  "#f3f3fc",
                  "#fffaf0",
                ];
                const bgColor = bgColors[index % bgColors.length];
                const isOpen = openBoxIndex === `${year}-${index}`;

                return (
                  <div
                    key={index}
                    className="programas-subbox"
                    style={{
                      backgroundColor: bgColor,
                      marginBottom: "10px",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      setOpenBoxIndex(isOpen ? null : `${year}-${index}`)
                    }
                  >
                    <div>
                      <h6>{item.titulo}</h6> <div>{isOpen ? "▲" : "▼"}</div>
                    </div>
                    {isOpen && (
                      <div className="programas-details">
                        <p style={{ marginBottom: 0 }}>
                          <strong>Ubicación:</strong> {item.comuna}, Region{" "}
                          {item.region}
                          <br />
                          <strong>Empresa:</strong> {item.empresa}
                          <br />
                          <strong>Otec:</strong> {item.otec}
                          <br />
                          {item.asociado && (
                            <>
                              <strong>Asociado:</strong> {item.asociado}
                              <br />
                            </>
                          )}
                          <strong>Inicio:</strong> {item.inicio}
                        </p>
                      </div>
                    )}
                  </div>
                );
              })}
            </VerticalTimelineElement>
          );

          const customEvents = interYearEvents
            .filter((event) => event.position.startsWith(year))
            .map((event) => (
              <VerticalTimelineElement
                key={event.id}
                date={`Evento Especial`}
                iconStyle={{
                  background: event.iconColor || "#aaa",
                  color: "#fff",
                  boxShadow: `0 0 0 4px ${event.iconColor || "#ccc"}50`,
                }}
                contentStyle={{
                  background: event.backgroundColor || "#f9f9f9",
                  borderLeft: `6px solid ${event.iconColor || "#ccc"}`,
                  boxShadow: "0 3px 10px rgba(0,0,0,0.05)",
                }}
                contentArrowStyle={{
                  borderRight: `7px solid ${event.iconColor || "#ccc"}`,
                }}
              >
                <h3 className="vertical-timeline-element-title">
                  {event.title}
                </h3>
                {event.subtitle && (
                  <p className="timeline-subtitle">{event.subtitle}</p>
                )}
                {event.images?.length > 0 && (
                  <div className="timeline-image-grid">
                    {event.images.map((img, i) => (
                      <img
                        key={i}
                        src={getStaticUrl(img)}
                        alt={`event-${event.id}-${i}`}
                        className="timeline-image"
                      />
                    ))}
                  </div>
                )}
              </VerticalTimelineElement>
            ));

          return [yearElement, ...customEvents];
        })}
      </VerticalTimeline>
    </div>
  );
}

export default Programa;
